import { Tip } from '../model/object';
import { IField } from '../model/field';

export type FieldTip = Tip;
export type FieldTipFieldMap = Map<FieldTip, IField>;

export function createFieldsMap(fields: IField[] = []): FieldTipFieldMap {
  const map = new Map<FieldTip, IField>();

  fields.forEach(field => map.set(field.$tip, field));
  return map;
}
